

class Input extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        var value = this.props.value ? this.props.value : '';
        var additionalAttributes = {...this.props};
        delete additionalAttributes.value;

        return <input value={value} {...additionalAttributes} />;
    }
}

export default Input;